import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import BranchPickerModal from "@/components/site/BranchPickerModal";
import { scrollToSection } from "@/lib/scroll";

const go = (id) => scrollToSection(id);

export default function CTA() {
  const [waOpen, setWaOpen] = useState(false);

  const handleSelect = (branch) => {
    const msg = encodeURIComponent(
      `Hola ${branch.name}, quiero información sobre los cursos del Instituto Europa.`
    );
    window.open(`https://wa.me/${branch.whatsapp}?text=${msg}`, "_blank", "noopener");
    setWaOpen(false);
  };

  return (
    <section
      className="relative overflow-hidden bg-[#c40000] text-white"
      data-testid="cta-section"
    >
      <div className="container-ie py-20 md:py-28 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl"
        >
          <span className="inline-flex items-center gap-2 text-[0.7rem] uppercase tracking-[0.22em] font-semibold mb-6">
            <span className="w-1.5 h-1.5 bg-white rounded-full" />
            Tu próximo paso
          </span>
          <h2
            className="font-display font-semibold tracking-tighter text-5xl md:text-6xl lg:text-7xl leading-[1.02]"
            data-testid="cta-title"
          >
            Tu futuro en la belleza{" "}
            <span className="italic font-light">comienza hoy.</span>
          </h2>
          <p className="mt-8 max-w-2xl text-base md:text-lg font-light leading-relaxed text-white/85">
            Una sola decisión puede cambiar tu carrera. Solicita información
            sobre nuestros cursos, becas disponibles y planes de financiamiento.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <button
              data-testid="cta-info-button"
              onClick={() => go("contacto")}
              className="inline-flex items-center gap-2 px-7 py-4 bg-white text-[#0a0a0a] text-xs font-semibold uppercase tracking-[0.18em] hover:bg-[#0a0a0a] hover:text-white transition-colors"
            >
              Programar visita <ArrowRight size={16} strokeWidth={1.8} />
            </button>
            <button
              type="button"
              data-testid="cta-whatsapp-button"
              onClick={() => setWaOpen(true)}
              className="inline-flex items-center gap-2 px-7 py-4 border border-white/40 text-white text-xs font-semibold uppercase tracking-[0.18em] hover:bg-white hover:text-[#c40000] transition-colors"
            >
              Hablar por WhatsApp
            </button>
          </div>
        </motion.div>
      </div>

      <div className="absolute right-0 bottom-0 select-none pointer-events-none opacity-[0.08]">
        <div className="font-display font-bold text-[14rem] md:text-[22rem] leading-none tracking-tighter text-white">
          IE
        </div>
      </div>

      <BranchPickerModal
        open={waOpen}
        mode="whatsapp"
        course={null}
        onClose={() => setWaOpen(false)}
        onSelect={handleSelect}
      />
    </section>
  );
}
